import InputBadge from './InputBadge';

export default InputBadge;
